import { css } from 'styled-components';

const boundary = css`
  border: 1px solid #bdbdbd;
  border-radius: ${({ rounded }) => (rounded ? 4 : 0)}px;
`;

export default boundary;
